import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ArrowRight, Phone } from "lucide-react";
import { useQuoteForm } from "@/components/QuoteFormContext";
import { Button } from "@/components/ui/button";
import LocationMap from "@/components/LocationMap";
import DeferUntilVisible from "@/components/DeferUntilVisible";
import { siteConfig } from "@/lib/site-config";

/** Matches the rendered map height so deferring it shifts nothing. */
const MAP_MIN_HEIGHT = 568;

const ServiceAreas = () => {
  const { openQuoteForm } = useQuoteForm();

  return (
    <section id="locations" className="section-padding bg-background">
      <div className="container-max">
        <div className="text-center mb-14 md:mb-16">
          <Reveal
            as="span"
            y={10}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Coverage
          </Reveal>
          <Reveal
            as="h2"
            y={20}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            Areas We <span className="text-gradient-primary">Serve</span>
          </Reveal>
          <Reveal
            as="p"
            y={15}
            delay={0.1}
            className="text-muted-foreground max-w-2xl mx-auto text-lg"
          >
            Based in Phoenix — serving 15+ cities across Maricopa and Pinal County, from Surprise
            and Goodyear in the West Valley out to Apache Junction, Florence, and Casa Grande.
          </Reveal>
        </div>

        <Reveal
          as="div"
          y={30}
          duration={0.6}
          className="max-w-6xl mx-auto"
        >
          <DeferUntilVisible minHeight={MAP_MIN_HEIGHT}>
            <LocationMap />
          </DeferUntilVisible>
        </Reveal>

        <Reveal
          as="div"
          y={20}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10 md:mt-12"
        >
          <Button size="lg" onClick={openQuoteForm} className="gap-2 px-7 rounded-xl font-semibold">
            Get Free Estimate
          </Button>
          <Button asChild
            variant="outline" size="lg" className="gap-2 px-7 rounded-xl font-semibold"
          >
            <Link to="/locations">View All Areas <ArrowRight className="h-5 w-5" /></Link>
          </Button>
          <Button asChild
            variant="secondary" size="lg" className="gap-2 px-7 rounded-xl font-semibold"
          >
            <a href={siteConfig.phoneHref}><Phone className="h-4 w-4" /> {siteConfig.phone}</a>
          </Button>
        </Reveal>
      </div>
    </section>
  );
};

export default ServiceAreas;
